import Balance from 'components/common/balance/balance';
import TokenAmount from 'components/wallet/token-amount';

import { useAppSelector } from 'redux/use-hooks';
import { selectNearTokenFiatValueUSD } from 'redux/slices/tokenFiatValues';

const RawTokenAmount = ({
  symbol,
  amount,
  decimals = null
}) => {
  const nearTokenFiatValueUSD = useAppSelector(selectNearTokenFiatValueUSD);

  if (decimals !== null && symbol) {
    return (
      <TokenAmount
        amount={amount}
      />
    );
  } else {
    return (
      <Balance
        amount={amount}
        symbol={symbol}
        nearTokenFiatValueUSD={nearTokenFiatValueUSD}
      />
    );
  }
};

export default RawTokenAmount;
